import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTableRegularPencilIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m16.5 13.5-4 4q-.4.6-1.2.7l-2 .4h-.1a.5.5 0 0 1-.5-.6l.4-2q.2-.7.6-1.2l4.1-4zM15.2 2q2 .2 2.2 2.2v3.2q-.8-.3-1.6 0V4.2q0-.5-.6-.5H8v2.7h5.3q.7.1.8.8-.1.8-.8.8H8v5.3a.8.8 0 1 1-1.6 0V8H3.7v7.2q0 .5.5.6h3.2q-.3.7 0 1.6H4.2q-2-.2-2.2-2.2v-11q.2-2 2.2-2.2zm.4 7a2 2 0 1 1 2.7 2.7l-1 1-2.7-2.7zM4.2 3.7q-.5 0-.5.5v2.2h2.7V3.7z" })
});
export default SvgTableRegularPencilIcon;
